import React from 'react';
import AppContents from './AppContents.js';
import GQLMotion from './GQLMotion.js';
import '../static/css/frame.css';

class AppFrame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            welcome:true,
            hover:false,
            darken:false
        }
    }
    componentDidMount() {
    }
    componentDidUpdate(prevProps,prevState,snapshot) {
    }
    render() {
        return (
            <div
                style={{
                    display:'flex',
                    flexDirection:'column',
                    width:'600px',
                    height:'600px',
                    paddingLeft:'30px',
                    paddingTop:'30px',
                    minWidth:'600px'
                }}
            >
                <AppContents />
                <div
                    id='welcomeScreen'
                    style={{
                        width:'inherit',
                        height:'inherit',
                        position:'absolute',
                        backgroundColor:(this.state.hover) ? 'rgba(0,0,0,0.9)' : 'rgba(0,0,0,0.5)',
                        display:(this.state.welcome) ? 'flex' : 'none',
                        flexDirection:'column',
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                    onMouseEnter={e=>{
                        this.setState({
                            ...this.state,
                            hover:true
                        })
                    }}
                    onMouseLeave={e=>{
                        this.setState({
                            ...this.state,
                            hover:false
                        })
                    }}
                    onMouseOut={e=>{
                        this.setState({
                            ...this.state,
                            hover:false
                        })
                    }}
                    onMouseMove={e=>{
                        this.setState({
                            ...this.state,
                            hover:true
                        })
                    }}
                >
                    <div
                        style={{
                            height:'auto',
                            display:'flex',
                            flexDirection:'column',
                            justifyContent:'space-between'
                        }}
                    >
                        <GQLMotion animate={this.state.hover} size={200} />
                        <h3 style={{color:'white'}}>Are you ready?</h3>
                        <button
                            id='startButton'
                            onClick={e=>{
                                let newState = this.state;
                                newState.welcome = false;
                                this.setState(newState);
                            }}
                        >Begin!</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default AppFrame;